import React from "react";
import { Switch } from "antd";
import { useMutation } from "@apollo/client";
import { LANGUAGE_UPDATE } from "graphql/mutation/language-gql";
import { GET_LANGUAGES, GET_LANGUAGES_ALL, GET_LANGUAGES_PAGINATED } from "graphql/query/language-gql";
import { errorNotification, successNotification } from "components/request-result";


const LanguageStatusField = ({ language }) => {
    const [ languageUpdateRequest, { loading } ] = useMutation(LANGUAGE_UPDATE, {
        refetchQueries: [ GET_LANGUAGES, GET_LANGUAGES_ALL, GET_LANGUAGES_PAGINATED ],
        update(cache, { data }) {
            const {
                languageUpdate: {
                    label,
                    message
                }
            } = data;

            successNotification({
                title: label,
                description: message
            });
        },
        onError(error) {
            errorNotification(error);
        }
    });

    return (
        <Switch
            checked={ language.status }
            loading={ loading }
            disabled={ loading }
            onChange={ (checked) => {
                languageUpdateRequest({
                    variables: {
                        id: language.id,
                        input: {
                            label: language.label,
                            slug: language.slug,
                            status: checked,
                        }
                    }
                }).catch((error) => {
                    errorNotification(error);
                });
            } } />
    );
};

export default LanguageStatusField;
